export const referralKeys = {
  all: () => ['referrals'] as const,
  template: (locationId: string, recipientPracticeId: string | null) =>
    ['referrals', 'template', locationId, recipientPracticeId ?? 'none'] as const,
  settings: (locationId: string) => ['referrals', 'settings', locationId] as const,
  stats: (locationId: string) => ['referrals', 'stats', locationId] as const,
  listPrefix: (locationId: string) => ['referrals', 'list', locationId] as const,
  list: (locationId: string, box: string, status: string, q: string) =>
    ['referrals', 'list', locationId, box, status, q] as const,
  detail: (locationId: string, id: string) => ['referrals', 'detail', locationId, id] as const,
  directorySearch: (locationId: string, q: string) =>
    ['referrals', 'directory', 'search', locationId, q] as const,
  suggested: (locationId: string, specialty: string, reasons: string, comment: string) =>
    ['referrals', 'directory', 'suggested', locationId, specialty, reasons, comment] as const,
  directoryDelivery: (locationId: string, id: string) =>
    ['referrals', 'directory', 'delivery', locationId, id] as const,
  directoryPractice: (locationId: string, id: string) =>
    ['referrals', 'directory', 'practice', locationId, id] as const,
  publicView: (token: string) => ['referrals', 'public', token] as const,
  patientView: (token: string) => ['referrals', 'patient', token] as const,
};
